import {
  BMComponentsType,
  BMDivider,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { useTravelerPickerContextV2 } from "../../../../providers/TravelerPickerContextV2";
import { formatMessage } from "../../../../utils";
import CheckboxEmployee from "./CheckboxEmployee";
import { FormValues } from "./types";

const setValueConfig = {
  shouldDirty: true,
  shouldTouch: true,
};

type Props = {
  onOpenEmployeePicker(): void;
};

export default function TravelerPickerSelectEmployeeContent({
  onOpenEmployeePicker,
}: Props) {
  const { type } = useTravelerPickerContextV2();
  const { CorporateTravelerPicker: cr } = useMobileContentResource();
  const { control, setValue } = useFormContext<FormValues<any>>();
  const employees = useWatch({ control, name: "employees" });

  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);

  if (!employees || !employees.length) {
    return (
      <BMView style={styles.container} spacing="lg">
        <BMText variant="uiLargeLi" ink="BMStyleTextInkSecondary">
          {formatMessage(cr.selectedEmployeeSectionTitle, { num: 0 })}
        </BMText>
        <BMView style={[styles.innerWrapper, styles.padding]} spacing="xs">
          <BMText variant="paragraphNormal" ink="BMStyleTextInkSecondary">
            {cr.emptyEmployeeInfoText}
          </BMText>
          <BMText
            testID="add_employee-button"
            ink="BMStyleTextInkAction"
            onPress={onOpenEmployeePicker}
          >
            {formatMessage(cr.addEmployeeButtonText, {
              type,
            })}
          </BMText>
        </BMView>
      </BMView>
    );
  }

  return (
    <BMView style={styles.container} spacing="lg">
      <BMText variant="uiLargeLi" ink="BMStyleTextInkSecondary">
        {formatMessage(cr.selectedEmployeeSectionTitle, {
          num: employees.length,
        })}
      </BMText>
      <BMView style={styles.innerWrapper}>
        {employees.map((employee, index) => (
          <Fragment key={index}>
            <CheckboxEmployee
              testID={`selected_employee-checkbox-${index}`}
              style={styles.padding}
              value
              employee={employee}
              onChange={() =>
                setValue(
                  "employees",
                  employees.filter((_, i) => i !== index),
                  setValueConfig
                )
              }
            />
            <BMDivider type="SUBTLE" />
          </Fragment>
        ))}
        <BMView style={styles.padding}>
          <BMText ink="BMStyleTextInkAction" onPress={onOpenEmployeePicker}>
            {formatMessage(cr.addEmployeeButtonText, { type })}
          </BMText>
        </BMView>
      </BMView>
    </BMView>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    container: {
      paddingHorizontal: BMPrimitives.BMSize.md,
      paddingTop: BMPrimitives.BMSize.lg,
      paddingBottom: BMPrimitives.BMSize.xl2,
    },
    innerWrapper: {
      borderColor: BMComponents.BMStyleLineBordercolorSubtle,
      borderWidth: BMPrimitives.BMBorder.width.thick,
      borderRadius: BMComponents.BMStyleCardRadiusCompact,
    },
    padding: {
      padding: BMPrimitives.BMSize.md,
    },
  });
}
